




import {AssignPickupStatus, DivisionPickupStatus} from "@/enums/status";
import {Component, Prop, Vue} from "vue-property-decorator";
import {IdMapper} from "@/interfaces/state/base";

@Component({
    name : "DivisionPickupStatusLabel"
})
export default class extends Vue {
    @Prop({ required: true})
    readonly status!: number;
    DivisionPickupStatus = DivisionPickupStatus;
    colorMap: IdMapper<string> = {
        [DivisionPickupStatus.ChoXacNhan]: "blue",
        [DivisionPickupStatus.LayThanhCong]: "green",
        [DivisionPickupStatus.ShipperHuy]: "red",
        [DivisionPickupStatus.XacNhanLay]: "yellow",
        [DivisionPickupStatus.DaPhanLai]: "yellow"
    }
    
}
